const sortOffersByExpiringSoonest = (offers) => {
  offers.sort((a, b) => {
    if (a.isOngoing === b.isOngoing) {
      return new Date(a.stopDatetime) - new Date(b.stopDatetime);
    }
    if (a.isOngoing) {
      return 1;
    }
    if (b.isOngoing) {
      return -1;
    }
    return 0;
  });
};

const shuffleArrayInPlace = (array) => array.map((value) => ({ value, sort: Math.random() }))
  .sort((a, b) => a.sort - b.sort)
  .map(({ value }) => value);

export const sortMerchantsOfferList = (offers, favorites) => {
  const merchantsOffersWithElevationAndCouponCode = [];
  const merchantsOffersWithElevation = [];
  const merchantsOffersWithCode = [];
  const merchantsWithOffer = [];
  const merchantsWithoutOffer = [];

  offers.forEach((offer) => {
    const isElevatedOffer = offer.merchant && offer.merchant.rebate &&
      offer.merchant.rebate.elevation;

    if (isElevatedOffer && offer.couponCode) {
      merchantsOffersWithElevationAndCouponCode.push(offer);
    } else if (isElevatedOffer) {
      merchantsOffersWithElevation.push(offer);
    } else if (offer.couponCode) {
      merchantsOffersWithCode.push(offer);
    } else if (offer.id) {
      merchantsWithOffer.push(offer);
    } else {
      merchantsWithoutOffer.push(offer);
    }
  });

  // Sort all offers by expiring soonest
  sortOffersByExpiringSoonest(merchantsOffersWithElevationAndCouponCode);
  sortOffersByExpiringSoonest(merchantsOffersWithElevation);
  sortOffersByExpiringSoonest(merchantsOffersWithCode);
  sortOffersByExpiringSoonest(merchantsWithOffer);
  shuffleArrayInPlace(merchantsWithoutOffer);

  return Array.prototype.concat(merchantsOffersWithElevationAndCouponCode,
    merchantsOffersWithElevation, merchantsOffersWithCode, merchantsWithOffer,
    merchantsWithoutOffer)
    .filter(item => {
      const { merchant: { id } } = item;
      return favorites[id];
    });
};
